import { render, staticRenderFns } from "./FreeText.vue?vue&type=template&id=002a8f1c&scoped=true&"
import script from "./FreeText.vue?vue&type=script&lang=js&"
export * from "./FreeText.vue?vue&type=script&lang=js&"
import style0 from "./FreeText.vue?vue&type=style&index=0&id=002a8f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a8f1c",
  null
  
)

/* custom blocks */
import block0 from "./FreeText.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports